






























































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {SortOption} from '@/types/SortOption'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'

@Component({
  components: {
    VueMultiselect,
  },
})
export default class DappDetailedOrbitContentFilter extends Vue {
  @Prop({type: Array, required: true}) rounds!: number[]
  @Prop({type: Number, required: true}) selectedRound!: number
  @Prop({type: Number, required: false, default: 0})
  activeRound!: number

  selectedRoundComputed: {
    $id: number
    field: string
    asc: boolean
    $tag: string
  } = {
    $id: this.selectedRound,
    field: `Round ${this.selectedRound}`,
    asc: false,
    $tag: `Round ${this.selectedRound}`,
  }

  get activeRoundComputed() {
    return this.activeRound
      ? {
          $id: this.activeRound,
          field: `Round ${this.activeRound}`,
          asc: false,
          $tag: `Round ${this.activeRound}`,
        }
      : null
  }

  @Watch('selectedRound', {immediate: true})
  onSelectedRoundChange(newValue: number) {
    this.selectedRoundComputed = {
      $id: newValue,
      field: `Round ${newValue}`,
      asc: false,
      $tag: `Round ${newValue}`,
    }
  }

  get roundsComputed() {
    return this.rounds.map(round => ({
      $id: round,
      field: `Round ${round}`,
      asc: false,
      $tag: `Round ${round}`,
    }))
  }

  onFilter(option: SortOption) {
    this.$emit('filter', option.$id)
  }
}
